import React from 'react';
import { EntityTaskDetails } from 'components/common/tasks/entityTaskDetails';

export const BrandTaskDetails = () => {
  return <EntityTaskDetails entityName={'BRAND'} />;
};
